/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {CTCEntity} from '@ion/core/src/types/entities';

/**
 * Provides a utility hook for getting the bulk import operation results for any entity via
 * its respective reducer ...
 *
 * ```typescript
 *
 *   import {useBulkImportResults} from '@ion/dls/src/hooks/';
 *   const bulkImportResult = useBulkImportResults('reducer');
 *
 * ```
 */
export const useBulkImportResults = (reducer: string): CTCEntity | CTCEntity[] => {
  return useSelector(({[reducer]: {bulkImport}}) => bulkImport?.result);
};

export default useBulkImportResults;
